import { render, staticRenderFns } from "./UserFormPage.vue?vue&type=template&id=57bfacde&scoped=true"
import script from "./UserFormPage.vue?vue&type=script&lang=js"
export * from "./UserFormPage.vue?vue&type=script&lang=js"
import style0 from "./UserFormPage.vue?vue&type=style&index=0&id=57bfacde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bfacde",
  null
  
)

export default component.exports